import React, { useEffect, useState } from "react";
import useWishlist from "./useWishlist";
import useGuestWishlist from "./useGuestWishlist";
import { useAuth } from "../../../utils/AuthContext";
import useFetchProduct from "../../adminDashboard/products/useFetchProduct";

import CustomLoading from "../../../utils/LoadingIndicator/CustomLoading";
// import { useAuth } from "../../utils/AuthContext";
// import useFetchProduct from "../products/useFetchProduct";

function ManageWishlist({ productId }) {
  const [isHovered, setIsHovered] = useState(false);
  const [product, setProduct] = useState(null);
  const { isLoggedIn } = useAuth();

  const { getOneProductFn } = useFetchProduct();

  useEffect(() => {
    async function fetchProduct() {
      const prod = await getOneProductFn(productId);
      setProduct(prod);
    }
    fetchProduct();
  }, [productId]);

  // For logged-in users
  const {
    addToWishlistFn,
    removeFromWishlistFn,
    isInWishlist: isInLoggedInWishlist,
    isAddingToWishlist,
    isRemovingFromWishlist,
  } = useWishlist(isLoggedIn);

  // For guest users
  const {
    addToWishlist: addToGuestWishlist,
    removeFromWishlist: removeFromGuestWishlist,
    isInWishlist: isInGuestWishlist,
  } = useGuestWishlist();

  const isItemInWishlist = isLoggedIn
    ? isInLoggedInWishlist(productId)
    : isInGuestWishlist(productId);
  // console.log("is item in wishlist: ", isItemInWishlist);
  const handleWishlistAction = () => {
    if (isLoggedIn) {
      if (isItemInWishlist) {
        removeFromWishlistFn(productId);
      } else {
        if (product) {
          // console.log("Adding to wishlist: ", product);
          addToWishlistFn({
            productId: product._id,
            priceAtAdded: product.price,
          });
        }
      }
    } else {
      if (isItemInWishlist) {
        removeFromGuestWishlist(productId);
      } else {
        addToGuestWishlist(productId);
      }
    }
  };

  return (
    <div>
      <button
        onClick={handleWishlistAction}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        disabled={isAddingToWishlist || isRemovingFromWishlist}
        className="wishlist-button text-[#DA0E1A] p-2 px-[0.6rem]"
        title={isItemInWishlist ? "remove from wishlist" : "add to wishlist"}
      >
        {isAddingToWishlist || isRemovingFromWishlist ? (
          <CustomLoading size="1.5rem" />
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={35}
            height={35}
            viewBox="0 0 24 24"
            className={`fill-transparent transition-colors duration-300 ${
              isItemInWishlist ? "fill-[#DA0E1A]" : ""
            }`}
          >
            <path
              fill={isHovered || isItemInWishlist ? "#DA0E1A" : "transparent"}
              d="M2 9.137C2 14 6.02 16.591 8.962 18.911C10 19.729 11 20.5 12 20.5s2-.77 3.038-1.59C17.981 16.592 22 14 22 9.138S16.5.825 12 5.501C7.5.825 2 4.274 2 9.137"
              strokeWidth={1}
              stroke="#DA0E1A"
            />
          </svg>
        )}
      </button>
    </div>
  );
}

export default ManageWishlist;
